<template>
  <div style="background:#f6f6f6">
    <van-tabs v-model="active" @change="changeTab" :before-change="isswitch">
      <van-tab :title="item.name" v-for="(item, i) in tabList" :key="i"
        ><div style="height:.305rem"></div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="item"
            :style="{
              background: 'url(' + bgc + ')',
              backgroundSize: 'cover'
            }"
            v-for="(item, i) in couponList"
            :key="i"
          >
            <img v-if="item.goodsUrl" :src="item.goodsUrl" alt="" />
            <img v-else src="@/assets/img/couponM.png" alt="" />
            <div class="rgt">
              <div class="title">{{ item.ticketName }}</div>
              <div class="sell">
                <span>&yen;{{ item.voucherCashValue / 100 }}</span>
                <template v-if="item.batchSalesAmount">
                  已售 {{ item.batchSalesAmount }}
                </template>
              </div>
              <div
                class="btn"
                @click="
                  $router.push(
                    '/couponDetail?brandId=' +
                      item.brandId +
                      '&ticketId=' +
                      item.ticketId
                  )
                "
              >
                立即购买
              </div>
            </div>
          </div>
        </van-list></van-tab
      >
    </van-tabs>
  </div>
</template>
<script>
import { getMorePageInfo } from '@/api/floor'
import { getCurrentDate } from '@/utils/util'
import { behaviorCollect } from '@/api/track'
export default {
  data() {
    return {
      isswitch: () => {
        return !this.switch
      },
      bgc: require('@/assets/img/couponbgc.png'),
      switch: false,
      active: 0,
      finished: false,
      loading: false,
      couponList: [],
      tabList: [],
      pageSize: 10,
      pageNum: 1
    }
  },
  created() {
    this.getList()
    if (this.$route.query.typeId) {
      this.finished = true
    }
  },
  mounted() {
    this.sendBehaviorData()
  },
  computed: {},
  methods: {
    changeTab() {
      this.couponList = []
      this.pageNum = 1
      this.onLoad()
    },
    onLoad() {
      this.switch = true
      this.finished = false
      this.loading = true
      getMorePageInfo({
        typeId: this.tabList[this.active].code,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      })
        .then(res => {
          if (!res.data) {
            this.finished = true
          } else {
            this.couponList.push(...res.data.ticketList)
          }
          this.loading = false
          this.pageNum++
          this.switch = false
        })
        .catch(() => {
          this.switch = false
        })
    },
    getList() {
      getMorePageInfo({
        typeId: '',
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }).then(res => {
        this.tabList.push({ code: '', name: '全部' })
        this.tabList.push(...res.data.typeDictList)
        if (this.$route.query.typeId) {
          const num = this.tabList.findIndex(item => {
            return item.code === this.$route.query.typeId
          })
          this.$nextTick(() => {
            this.active = num
            this.changeTab()
          })
        }
      })
    },
    // 行为数据采集
    sendBehaviorData() {
      const params = {
        ip: returnCitySN.cip, // ip地址
        os: isIOS ? 'iphone' : 'android', // 系统名称
        occTime: getCurrentDate(), // 发生时间
        actionType: '1', // 动作类型 下单-9，访问-1，点击-2
        appName: 'app', // 系统名称：商城、app
        channelName: this.$store.getters.environmenta, // 渠道名称：公众号 wechat_mp 、微信小程序：wechat_miniapp 、app端：app
        busiCode: '020002', // 业务编码
        busiName: '生活卡券', // 业务名称
        busiDesc: '', // 业务描述
        transNo: '', // 行为流水号：无订单号传空字符串
        subjectCode: 'voucher', // 主体编码
        subjectName: '生活卡券', // 主体名称
        subjectAmt: '', // 产品金额（分为单位）
        lev1: '', // 一级类目
        lev2: '', // 二级类目
        lev3: '' // 三级类目
      }
      behaviorCollect(params).then(res => {})
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-tabs {
  background: #fbfbfb;
  .van-tabs__wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    height: 0.265rem;
    padding-top: 0.1rem;
    background-color: #fbfbfb;
    padding-bottom: 0.075rem;
    width: 3.75rem;

    .van-tabs__nav--line {
      padding-bottom: 0.075rem;
    }
    .van-tabs__nav {
      padding-left: 0.145rem;
      padding-right: 0.145rem;
      background: #fbfbfb;
      overflow: auto;
      .van-tab {
        padding: 0 0.165rem;
        flex: 1 0 auto;
        .van-tab__text {
          font-size: 0.15rem;
          font-weight: 500;
          text-align: center;
          line-height: 0.21rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #333333;
        }
      }
      .van-tab--active {
        .van-tab__text {
          font-family: PingFangSC, PingFangSC-Medium;
          color: #f46264;
        }
      }
      .van-tabs__line {
        bottom: 0.075rem;
        left: 0;
        z-index: 1;
        width: 0.21rem;
        height: 0.015rem;
        background: #f46264;
        border-radius: 0.015rem;
      }
    }
  }
  .van-tabs__content {
    margin-top: 0.1rem;
  }
}
.item {
  margin: 0.15rem 0.15rem 0;
  width: 3.45rem;
  height: 0.875rem;
  background-image: url('~@/assets/img/couponbgc.png');
  box-shadow: 0px 0.01rem 0.02rem 0px rgba(192, 192, 192, 0.08);
  img {
    // margin-top: 0.11rem;
    // margin-left: 0.1rem;
    // margin-right: 0.0975rem;
    margin: 0.11rem 0.14rem 0;
    // width: 0.98rem;
    width: 0.68rem;
    height: 0.68rem;
    float: left;
    border-radius: 0.04rem;
  }
  .rgt {
    position: relative;

    float: left;
    height: 0.755rem;
    // border-left: 0.01rem dashed #e1e1e1;
    padding-top: 0.195rem;
    padding-left: 0.1125rem;
    box-sizing: border-box;

    .title {
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #333333;
      line-height: 0.2rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 2.02rem;
    }
    .sell {
      margin-top: 0.15rem;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 400;
      text-align: left;
      color: #b3b3b3;
      display: flex;
      line-height: 0.2rem;
      align-items: flex-end;
      span {
        font-size: 0.18rem;
        display: inline-block;
        line-height: 0.2rem;
        // width: 0.5rem;
        margin-right: 0.1rem;
        color: #e90a0a;
      }
    }
    .btn {
      position: absolute;
      left: 1.64rem;
      top: 0.5rem;
      width: 0.71rem;
      height: 0.26rem;
      background: linear-gradient(53deg, #f46264 0%, #fb8606 100%);
      border-radius: 0.125rem;
      cursor: pointer;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      line-height: 0.26rem;
      color: #ffffff;
    }
  }
}
</style>
